import * as util from '../base/util';
import TaskRunner from '../base/TaskRunner';
import LiveEvent from '../base/LiveEvent';

TaskRunner.add(() => {
    // Кастомный vh
    util.refreshCustomVH();

    window.addEventListener('resize', () => {
        util.refreshCustomVH();
    });

    document.documentElement.style.setProperty('--scrollbarWidth', util.getScrollbarWidth() + 'px');

    LiveEvent.on('click', '.collapsible-block__toggle', (e, me) => {
        let cb = me.closest('.collapsible-block');

        if(cb){
            cb.style.maxHeight = cb.scrollHeight + 'px';
            cb.classList.toggle('expanded');
        }
    });
});